import FullScreenLoader from "../../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import swal from "sweetalert";
import Select from "react-select";
import { AddRoomDetails, GetResAgentList, GetResCorporatedetail, getReserRoomRateSelect, Property, ReservationMealplan, ReservationPreBooking, ReservationRateCode, ReservationRateCodeList, } from "../../../Services/Service"
import ReservationSidebar from "../../Commun/ReservationSidebar";
import ReservationHeader from "../../Commun/ReservationHeader";
import { useProperty } from "../../../PropertyContext";
// import { Ifream } from "./Ifream";

export const GroupBooking = () => {
    const navigate = useNavigate();
    const { selectedProperty } = useProperty();
    const prevPropertyIdRef = useRef(undefined);
    const [loading, setLoading] = useState(false);
    const [checkIn, setCheckIn] = useState("");
    const [checkOut, setCheckOut] = useState("");
    const [rateTypeCode, setRateTypeCode] = useState("Property");
    // const [rateCodeID] = useState("1");
    const [totalRoom, setTotalRoom] = useState(1);
    const [roomDetails, setRoomDetails] = useState([]);
    const [selectedPlans, setSelectedPlans] = useState({});
    const [roomCounts, setRoomCounts] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    const [agentList, setAgentList] = useState([]);
    const [selectedAgentId, setSelectedAgentId] = useState("");
    const [corporateList, setCorporateList] = useState([]);
    const [selectedCorporateId, setSelectedCorporateId] = useState("");
    const [roomOccupancy, setRoomOccupancy] = useState({});
    const [selectedRatePlans, setSelectedRatePlans] = useState({});
    const [selectedMealPlans, setSelectedMealPlans] = useState({});
    const [rateCodes, setRateCodes] = useState([]);
    const [Pms, setPMS] = useState();
    const [ratecode, setRatecode] = useState([]);
    const [, setMealplan] = useState([]);
    const [filteredMealplan, setFilteredMealplan] = useState([]);
    const [roomRates, setRoomRates] = useState({});


    useEffect(() => {
        const currentPropertyId = selectedProperty?.PropertyID;

        // Property abhi context me load nahi hui
        if (currentPropertyId === undefined || currentPropertyId === null) {
            return;
        }

        // First render par sirf property ID save hogi
        // Token clear ya page refresh nahi hoga
        if (prevPropertyIdRef.current === undefined) {
            prevPropertyIdRef.current = currentPropertyId;
            return;
        }

        // Header se property actually change hui hai
        if (prevPropertyIdRef.current !== currentPropertyId) {
            prevPropertyIdRef.current = currentPropertyId;

            // Purani booking ka token clear
            localStorage.removeItem("PreBookingToken");

            // Booking Search page refresh
            window.location.reload();
        }
    }, [selectedProperty?.PropertyID]);


    useEffect(() => {
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);

        setCheckIn(today.toISOString().split("T")[0]);
        setCheckOut(tomorrow.toISOString().split("T")[0]);
    }, []);

    const handleCheckInChange = (e) => {
        const selectedDate = e.target.value;
        setCheckIn(selectedDate);

        const nextDay = new Date(selectedDate);
        nextDay.setDate(nextDay.getDate() + 1);

        const formattedNextDay = nextDay.toISOString().split("T")[0];
        setCheckOut(formattedNextDay);
    };

    // rate code type
    useEffect(() => {
        const fetchRateCodestype = async () => {
            setLoading(true);
            try {
                const res = await ReservationRateCode();
                if (res) {
                    setRateCodes(res);
                }
            } catch (error) {
                console.error("Error fetching rate codes:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchRateCodestype();
    }, []);


    useEffect(() => {
        const FetchAgentName = async () => {
            try {
                const result = await GetResAgentList(selectedProperty?.PropertyID);
                if (Array.isArray(result)) {
                    const filtered = result.filter(a => a.TA_Name && a.AgentID);
                    setAgentList(filtered);
                }
            } catch (error) {
                console.log("error get Agent Name", error);
            }
        };
        FetchAgentName();
    }, [selectedProperty]);

    useEffect(() => {
        const FetchCorporateDetail = async () => {
            try {
                const result = await GetResCorporatedetail(selectedProperty?.PropertyID);
                if (Array.isArray(result)) {
                    const filtered = result.filter(
                        (corp) => corp.CorporateID && corp.TA_Name
                    );
                    setCorporateList(filtered);
                }
            } catch (error) {
                console.log("error get corporate detail", error);
            }
        };

        FetchCorporateDetail();
    }, [selectedProperty]);




    const handleSearch = async () => {
        if (!checkIn || !checkOut) {
            swal("Please select Check-In and Check-Out dates.", {
                icon: "warning",
            });
            return;
        }

        if (!selectedProperty?.PropertyID) {
            swal("Please select property.", { icon: "warning" });
            return;
        }

        //  Travel Agent validation
        if (rateTypeCode === "Travel Agent" && !selectedAgentId) {
            swal("Please select Travel Agent.", { icon: "warning" });
            return;
        }

        // Corporate validation
        if (rateTypeCode === "Corporate" && !selectedCorporateId) {
            swal("Please select Corporate.", { icon: "warning" });
            return;
        }

        if (!totalRoom || totalRoom <= 0) {
            swal("Please select total rooms.", { icon: "warning" });
            return;
        }

        setLoading(true);

        try {
            let finalRateCodeID = 0;

            if (rateTypeCode === "Travel Agent") {
                finalRateCodeID = selectedAgentId || 0;
            } else if (rateTypeCode === "Corporate") {
                finalRateCodeID = selectedCorporateId || 0;
            }

            const result = await ReservationPreBooking(
                selectedProperty.PropertyID,
                checkIn,
                checkOut,
                rateTypeCode,
                finalRateCodeID,
                totalRoom
            );

            // console.log("data", result?.RatePlan)
            setRoomDetails(result?.RatePlan || []);

            const token = result?.RoomDetails?.[0]?.PreBookingToken;
            if (token) {
                localStorage.setItem("PreBookingToken", token);
            }

        } catch (error) {
            console.error("error fetching booking", error);
            swal("Failed to fetch room availability.", { icon: "error" });
        } finally {
            setLoading(false);
        }
    };



    const handleRatePlanChange = (roomId, ratePlanCode, room) => {
        // try to find in room's own rateplans first
        const roomRatePlans = room?.RatePlan ? JSON.parse(room.RatePlan) : [];
        let selectedRatePlan = roomRatePlans.find(p => p.Code === ratePlanCode);

        // if not found in room, fallback to global ratecode from PropertyRateCode API
        if (!selectedRatePlan) {
            selectedRatePlan = ratecode.find(rc => rc.Code === ratePlanCode) || null;
        }

        setSelectedRatePlans(prev => ({
            ...prev,
            [roomId]: selectedRatePlan,
        }));

        // initialize selectedPlans so quantity/select room becomes available
        setSelectedPlans(prev => ({
            ...prev,
            [roomId]: {
                RatePlanID: selectedRatePlan?.RateCodeID ?? selectedRatePlan?.RatePlanID ?? null,
                RatePlanName: selectedRatePlan?.Name ?? selectedRatePlan?.Name ?? "",
                MealPlanCode: null,
                MealPlanName: null,
                PerRoomRate: 0,
                ExtraBedCharges: 0
            }
        }));

        // reset meal plan selection for that room (if you want)
        // setSelectedMealPlans(prev => ({
        //     ...prev,
        //     [roomId]: null
        // }));
    };



    const handleMealPlanChange = (roomId, mealPlanID) => {
        const mealPlan = filteredMealplan.find(mp => mp.MealPlanID === Number(mealPlanID)) || null;

        setSelectedMealPlans(prev => ({
            ...prev,
            [roomId]: mealPlan,
        }));

        setSelectedPlans(prev => ({
            ...prev,
            [roomId]: {
                ...prev[roomId],
                MealPlanCode: mealPlan?.Code || null,
                MealPlanName: mealPlan?.Name || null,
            }
        }));
    };


    const handleIncrement = async (roomID, maxAvailable) => {

        const currentCount = roomCounts[roomID] || 0;

        // ✅ NEW: available room limit check
        if (currentCount >= maxAvailable) {
            swal("Only limited rooms available.", {
                icon: "warning",
            });
            return;
        }

        const totalSelectedCount = Object.values(roomCounts).reduce((sum, count) => sum + count, 0);
        const totalRoomNum = Number(totalRoom) || 1;

        if (totalSelectedCount < totalRoomNum) {

            setRoomCounts((prev) => ({
                ...prev,
                [roomID]: currentCount + 1,
            }));

            // API call to get rate
            const ratePlanCode = selectedRatePlans[roomID]?.RateCodeID || "";
            const mealPlanID = selectedMealPlans[roomID]?.MealPlanID || 0;

            const rateTypeID =
                rateTypeCode === "Travel Agent"
                    ? selectedAgentId || 0
                    : rateTypeCode === "Corporate"
                        ? selectedCorporateId || 0
                        : 0;

            const rateCodeID = ratePlanCode || 0;
            const roomTypeID = roomID;
            const PropertyID = selectedProperty.PropertyID;

            try {
                const response = await getReserRoomRateSelect(
                    rateCodeID,
                    mealPlanID,
                    roomTypeID,
                    rateTypeCode || "",
                    rateTypeID,
                    PropertyID,
                    checkIn
                );

                const baseRate = response?.[0]?.BaseRate || 0;

                setSelectedPlans(prev => ({
                    ...prev,
                    [roomID]: {
                        ...prev[roomID],
                        PerRoomRate: baseRate
                    }
                }));

            } catch (error) {
                console.log("Error fetching room rate", error);
            }
        }
    };

    const handleDecrement = (roomID) => {
        setRoomCounts((prev) => {
            const current = prev[roomID] || 0;
            if (current <= 1) {
                const updated = { ...prev };
                delete updated[roomID];
                return updated;
            } else {
                return {
                    ...prev,
                    [roomID]: current - 1,
                };
            }
        });
    };

    const handleSelectRoom = async (roomID, maxAvailable) => {

        const requestedQty = Number(totalRoom) || 1;

        // ✅ limit laga di
        const finalQty = Math.min(requestedQty, maxAvailable);

        // ⚠️ alert agar user ne zyada select kiya
        if (requestedQty > maxAvailable) {
            swal(`Only ${maxAvailable} rooms available for this room type.`, {
                icon: "warning",
            });
        }

        // ✅ Set limited count
        setRoomCounts(prev => ({
            ...prev,
            [roomID]: finalQty
        }));

        // ===== Rate fetch same =====
        const ratePlanCode = selectedRatePlans[roomID]?.RateCodeID || "";
        const mealPlanID = selectedMealPlans[roomID]?.MealPlanID || 0;

        const rateTypeID =
            rateTypeCode === "Travel Agent"
                ? selectedAgentId || 0
                : rateTypeCode === "Corporate"
                    ? selectedCorporateId || 0
                    : 0;

        const rateCodeID = ratePlanCode || 0;
        const roomTypeID = roomID;
        const PropertyID = selectedProperty.PropertyID;

        try {
            const response = await getReserRoomRateSelect(
                rateCodeID,
                mealPlanID,
                roomTypeID,
                rateTypeCode || "",
                rateTypeID,
                PropertyID,
                checkIn
            );

            const baseRate = response?.[0]?.BaseRate || 0;

            setSelectedPlans(prev => ({
                ...prev,
                [roomID]: {
                    ...prev[roomID],
                    PerRoomRate: baseRate
                }
            }));

        } catch (error) {
            console.log("Error fetching room rate in handleSelectRoom", error);
        }
    };

    const totalSelectedCount = Object.values(roomCounts).reduce((sum, count) => sum + count, 0);

    const updateOccupancy = async (roomID, index, type, action) => {

        const key = `${roomID}-${index}`;

        setRoomOccupancy(prev => {

            const current = prev[key] || { adults: 1, children: 0, extraBed: 0 };

            const updated = {
                ...current,
                [type]: Math.max(1, current[type] + (action === "increment" ? 1 : -1)),
            };

            return {
                ...prev,
                [key]: updated,
            };
        });

        // Adult change par hi rate update karna hai
        if (type === "adults") {

            const adults =
                (roomOccupancy[key]?.adults || 1) +
                (action === "increment" ? 1 : -1);

            const ratePlanCode = selectedRatePlans[roomID]?.RateCodeID || "";
            const mealPlanID = selectedMealPlans[roomID]?.MealPlanID || 0;

            const rateTypeID =
                rateTypeCode === "Travel Agent"
                    ? selectedAgentId || 0
                    : rateTypeCode === "Corporate"
                        ? selectedCorporateId || 0
                        : 0;

            const rateCodeID = ratePlanCode || 0;
            const roomTypeID = roomID;
            const PropertyID = selectedProperty.PropertyID;

            try {

                const response = await getReserRoomRateSelect(
                    rateCodeID,
                    mealPlanID,
                    roomTypeID,
                    rateTypeCode || "",
                    rateTypeID,
                    PropertyID,
                    checkIn
                );

                const rateData = response?.[0];

                const newRate = calculateRoomRate(adults, rateData);

                // ⭐ key based rate store
                setRoomRates(prev => ({
                    ...prev,
                    [key]: newRate
                }));

            } catch (error) {
                console.log("Rate API error", error);
            }
        }
    };

    // const handleContinueBooking = async () => {
    //     if (!navigator.onLine) {
    //         swal("Network error. Please check your internet connection.", {
    //             icon: "error",
    //             buttons: {
    //                 confirm: {
    //                     text: "OK",
    //                     className: "btn btn-danger",
    //                 },
    //             },
    //         });
    //         return;
    //     }

    //     setLoading(true);
    //     const preBookingToken = localStorage.getItem("PreBookingToken");

    //     try {

    //         const missingMealPlans = [];

    //         for (const room of roomDetails) {
    //             const quantity = roomCounts[room.RoomID] || 0;
    //             if (quantity > 0) {
    //                 const meal = selectedMealPlans[room.RoomID];
    //                 // change condition if your meal object shape is different (e.g., check .MealPlanID)
    //                 if (!meal || (!meal.MealPlanID && !meal.Code)) {
    //                     missingMealPlans.push(room.RoomName || `RoomID ${room.RoomID}`);
    //                 }
    //             }
    //         }

    //         if (missingMealPlans.length > 0) {
    //             // build friendly message listing rooms
    //             const listStr = missingMealPlans.join(", ");
    //             swal({
    //                 title: "Select Meal Plan",
    //                 text: `Please select a meal plan for: ${listStr}`,
    //                 icon: "warning",
    //                 buttons: {
    //                     confirm: {
    //                         text: "OK",
    //                         className: "btn btn-warning"
    //                     }
    //                 }
    //             });
    //             setLoading(false);
    //             return; // stop further execution
    //         }

    //         for (const room of roomDetails) {
    //             const plan = selectedPlans[room.RoomID];
    //             const quantity = roomCounts[room.RoomID];

    //             if (plan && quantity) {
    //                 for (let i = 0; i < quantity; i++) {
    //                     // The popup keeps one occupancy selection per room type.
    //                     // Apply that same selection to every room of this type.
    //                     const occupancy = roomOccupancy[`${room.RoomID}-0`] || { adults: 1, children: 0, extraBed: 0 };

    //                     const finalRate = roomRates[`${room.RoomID}-0`] ?? plan?.PerRoomRate;

    //                     const extraBedCharges = Number(plan?.ExtraBedCharges) || 0;
    //                     const extraBedCount = Number(occupancy.extraBed) || 0;
    //                     const extraBedAmount = extraBedCount * extraBedCharges;

    //                     // Room rate + extra bed amount
    //                     const amount = finalRate + extraBedAmount;

    //                     const taxPercent = 5;
    //                     const taxRate = Number(
    //                         ((amount * taxPercent) / 100).toFixed(2)
    //                     );

    //                     const netAmount = Number(
    //                         (amount + taxRate).toFixed(2)
    //                     );

    //                     const formData = new FormData();
    //                     formData.append("PropertyID", selectedProperty.PropertyID)
    //                     formData.append("ID", "0");
    //                     formData.append("PreBookingToken", preBookingToken);
    //                     formData.append("RoomID", room.RoomID);
    //                     formData.append("RatePlanID", selectedRatePlans[room.RoomID]?.Code || 0);
    //                     formData.append("MealPlanID", selectedMealPlans[room.RoomID]?.Code || 0);
    //                     formData.append("TotalRoom", quantity);
    //                     formData.append("RoomRate", finalRate || 0);
    //                     formData.append("ExtraBed", occupancy.extraBed);
    //                     formData.append("ExtraBedAmount", occupancy.extraBed * plan.ExtraBedCharges || 0);
    //                     formData.append("Adults", occupancy.adults);
    //                     formData.append("Child", occupancy.children);
    //                     formData.append("Tax", taxPercent);
    //                     formData.append("TaxRate", taxRate);
    //                     formData.append("NetAmount", netAmount);

    //                     console.log("FormData to be sent:");
    //                     for (let pair of formData.entries()) {
    //                         console.log(pair[0], ":", pair[1]);
    //                     }

    //                     // API call of Room Add
    //                     const result = await AddRoomDetails(formData);

    //                     if (result?.PreBookingToken) {
    //                         swal("Your Room Booked In Hotel", {
    //                             icon: "success",
    //                             buttons: {
    //                                 confirm: {
    //                                     text: "OK",
    //                                     className: "btn btn-success",
    //                                 },
    //                             },
    //                         }).then(() => {
    //                             navigate("/Reservation/FinalBooking");
    //                         });
    //                     } else if (result?.Message) {
    //                         swal(result.Message, {
    //                             icon: "error",
    //                             buttons: {
    //                                 confirm: {
    //                                     text: "OK",
    //                                     className: "btn btn-danger",
    //                                 },
    //                             },
    //                         });
    //                         return;
    //                     }
    //                 }
    //             }
    //         }

    //     } catch (err) {
    //         if (err.response?.data?.Message) {
    //             alert(err.response.data.Message);
    //         } else {
    //             swal("Something went wrong. Please try again.", {
    //                 icon: "error",
    //                 buttons: {
    //                     confirm: {
    //                         text: "OK",
    //                         className: "btn btn-danger",
    //                     },
    //                 },
    //             });
    //         }
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    const handleContinueBooking = async () => {
        if (!navigator.onLine) {
            swal("Network error. Please check your internet connection.", {
                icon: "error",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-danger",
                    },
                },
            });
            return;
        }

        setLoading(true);
        const preBookingToken = localStorage.getItem("PreBookingToken");

        try {

            // ✅ RoomID ke basis par duplicate rooms hata do
            const uniqueRoomDetails = Array.from(
                new Map(roomDetails.map(room => [room.RoomID, room])).values()
            );

            const missingMealPlans = [];

            for (const room of uniqueRoomDetails) {
                const quantity = roomCounts[room.RoomID] || 0;
                if (quantity > 0) {
                    const meal = selectedMealPlans[room.RoomID];
                    if (!meal || (!meal.MealPlanID && !meal.Code)) {
                        missingMealPlans.push(room.RoomName || `RoomID ${room.RoomID}`);
                    }
                }
            }

            if (missingMealPlans.length > 0) {
                const listStr = missingMealPlans.join(", ");
                swal({
                    title: "Select Meal Plan",
                    text: `Please select a meal plan for: ${listStr}`,
                    icon: "warning",
                    buttons: {
                        confirm: {
                            text: "OK",
                            className: "btn btn-warning"
                        }
                    }
                });
                setLoading(false);
                return;
            }

            for (const room of uniqueRoomDetails) {
                const plan = selectedPlans[room.RoomID];
                const quantity = roomCounts[room.RoomID];

                if (!plan || !quantity) continue;

                const occupancy = roomOccupancy[`${room.RoomID}-0`] || { adults: 1, children: 0, extraBed: 0 };

                const finalRate = roomRates[`${room.RoomID}-0`] ?? plan?.PerRoomRate;

                const extraBedCharges = Number(plan?.ExtraBedCharges) || 0;
                const extraBedCount = Number(occupancy.extraBed) || 0;
                const extraBedAmount = extraBedCount * extraBedCharges;

                const amount = (finalRate + extraBedAmount) * quantity;

                const taxPercent = 5;
                const taxRate = Number(((amount * taxPercent) / 100).toFixed(2));
                const netAmount = Number((amount + taxRate).toFixed(2));

                const formData = new FormData();
                formData.append("PropertyID", selectedProperty.PropertyID);
                formData.append("ID", "0");
                formData.append("PreBookingToken", preBookingToken);
                formData.append("RoomID", room.RoomID);
                formData.append("RatePlanID", selectedRatePlans[room.RoomID]?.Code || 0);
                formData.append("MealPlanID", selectedMealPlans[room.RoomID]?.Code || 0);
                formData.append("TotalRoom", quantity);
                formData.append("RoomRate", finalRate || 0);
                formData.append("ExtraBed", occupancy.extraBed);
                formData.append("ExtraBedAmount", occupancy.extraBed * (plan.ExtraBedCharges || 0));
                formData.append("Adults", occupancy.adults);
                formData.append("Child", occupancy.children);
                formData.append("Tax", taxPercent);
                formData.append("TaxRate", taxRate);
                formData.append("NetAmount", netAmount);

                // console.log("FormData to be sent:");
                // for (let pair of formData.entries()) {
                //     console.log(pair[0], ":", pair[1]);
                // }

                const result = await AddRoomDetails(formData);

                if (result?.PreBookingToken) {
                    swal("Your Room Booked In Hotel", {
                        icon: "success",
                        buttons: {
                            confirm: {
                                text: "OK",
                                className: "btn btn-success",
                            },
                        },
                    }).then(() => {
                        navigate("/Reservation/FinalGroupBooking");
                    });
                } else if (result?.Message) {
                    swal(result.Message, {
                        icon: "error",
                        buttons: {
                            confirm: {
                                text: "OK",
                                className: "btn btn-danger",
                            },
                        },
                    });
                    return;
                }
            }

        } catch (err) {
            if (err.response?.data?.Message) {
                alert(err.response.data.Message);
            } else {
                swal("Something went wrong. Please try again.", {
                    icon: "error",
                    buttons: {
                        confirm: {
                            text: "OK",
                            className: "btn btn-danger",
                        },
                    },
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const formatDateToDDMMYYYY = (dateString) => {
        if (!dateString) return "";
        const [year, month, day] = dateString.split("-");
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        const FetchPMS = async () => {
            if (!selectedProperty?.PropertyID) return;

            try {
                const result = await Property();
                const matched = result.find(
                    p => p.PropertyID === selectedProperty.PropertyID
                );
                setPMS(matched || null);
            } catch (error) {
                console.log("error fetch PMS", error);
            }
        };
        FetchPMS();
    }, [selectedProperty]);


    useEffect(() => {
        const fetchRatecode = async () => {
            setLoading(true);
            try {
                const result = await ReservationRateCodeList(selectedProperty?.PropertyID);
                if (Array.isArray(result)) setRatecode(result);
            } catch (error) {
                console.log("error get rate code", error);
            } finally {
                setLoading(false);
            }
        };
        fetchRatecode();
    }, [selectedProperty]);

    useEffect(() => {
        const FetchMealplan = async () => {
            setLoading(true);
            try {
                const result = await ReservationMealplan(selectedProperty?.PropertyID);
                if (Array.isArray(result)) {
                    setMealplan(result);
                    setFilteredMealplan(result.filter(mp => mp.IsActive));
                }
            } catch (error) {
                console.log("error get meal plan", error);
            } finally {
                setLoading(false);
            }
        };
        FetchMealplan();
    }, [selectedProperty]);


    const calculateRoomRate = (adults, rateData) => {
        if (!rateData) return 0;

        const base = rateData.BaseRate || 0;
        const double = rateData.DoubleRate || 0;
        const triple = rateData.TripleRate || 0;

        if (adults === 1) return base;
        if (adults === 2) return double;
        if (adults === 3) return triple;

        if (adults > 3) {
            return triple + (adults - 3) * base;
        }

        return base;
    };

    return (
        <>
            {loading && (
                <FullScreenLoader />
            )}
            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="card-title">
                                                Reservation Group Booking
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <form>
                                                <div className="row">

                                                    <div className="col-md-2">
                                                        <div className="input-block ">
                                                            <label className="col-form-label fw-bold">Check-In</label>
                                                            <input type="date" className="form-control" value={checkIn} onChange={handleCheckInChange} />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-2">
                                                        <div className="input-block ">
                                                            <label className="col-form-label fw-bold">Check-Out</label>
                                                            <input type="date" className="form-control" value={checkOut}
                                                                onChange={(e) => setCheckOut(e.target.value)} />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-2">
                                                        <div className="input-block">
                                                            <label className="col-form-label fw-bold">Rate Type</label>

                                                            <select className="form-select form-control" value={rateTypeCode}
                                                                onChange={(e) => setRateTypeCode(e.target.value)}>
                                                                <option>Select type</option>
                                                                {rateCodes.map((item, index) => (
                                                                    <option key={index} value={item.RateCodeType}>
                                                                        {item.RateCodeType}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>


                                                    {rateTypeCode === "Travel Agent" && (
                                                        <div className="col-md-3">
                                                            <div className="input-block ">
                                                                <label className="col-form-label fw-bold">Select Travel Agent</label>



                                                                <Select
                                                                    options={agentList.map(agent => ({
                                                                        value: agent.AgentID,
                                                                        label: agent.TA_Name,
                                                                        maxRoom: agent.MaxRoomBook
                                                                    }))}
                                                                    placeholder="Select Agent"
                                                                    value={agentList
                                                                        .map(agent => ({
                                                                            value: agent.AgentID,
                                                                            label: agent.TA_Name,
                                                                            maxRoom: agent.MaxRoomBook
                                                                        }))
                                                                        .find(opt => opt.value === selectedAgentId)
                                                                    }
                                                                    onChange={(selected) => {
                                                                        setSelectedAgentId(selected?.value);

                                                                        if (selected?.maxRoom) {
                                                                            setTotalRoom(Math.min(totalRoom, selected.maxRoom));
                                                                        } else {
                                                                            setTotalRoom(1);
                                                                        }
                                                                    }}
                                                                    isSearchable={true}
                                                                    isClearable={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}


                                                    {/*  Conditional Select for Corporate */}
                                                    {rateTypeCode === "Corporate" && (
                                                        <div className="col-md-3">
                                                            <div className="input-block ">
                                                                <label className="col-form-label fw-bold">Select Corporate</label>


                                                                <Select
                                                                    options={corporateList.map(corp => ({
                                                                        value: corp.CorporateID,
                                                                        label: `${corp.TA_Name} (CP_${corp.CorporateCode || "N/A"})`,
                                                                        maxRoom: corp.MaxRoomBook
                                                                    }))}
                                                                    placeholder="Select Corporate"
                                                                    value={corporateList
                                                                        .map(corp => ({
                                                                            value: corp.CorporateID,
                                                                            label: `${corp.TA_Name} (CP_${corp.CorporateCode || "N/A"})`,
                                                                            maxRoom: corp.MaxRoomBook
                                                                        }))
                                                                        .find(opt => opt.value === selectedCorporateId)
                                                                    }
                                                                    onChange={(selected) => {
                                                                        setSelectedCorporateId(selected?.value);

                                                                        if (selected?.maxRoom) {
                                                                            setTotalRoom(Math.min(totalRoom, selected.maxRoom));
                                                                        } else {
                                                                            setTotalRoom(1);
                                                                        }
                                                                    }}
                                                                    isSearchable={true}
                                                                    isClearable={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}




                                                    <div className="col-md-2">
                                                        <div className="input-block ">
                                                            <label className="col-form-label fw-bold">Tolal Room</label>
                                                            <select className="form-select form-control" value={totalRoom}
                                                                onChange={(e) => setTotalRoom(e.target.value)}>
                                                                {(() => {
                                                                    let maxRoom = 70;

                                                                    if (rateTypeCode === "Travel Agent") {
                                                                        const agent = agentList.find(a => a.AgentID === Number(selectedAgentId));
                                                                        maxRoom = agent?.MaxRoomBook || 1;
                                                                    } else if (rateTypeCode === "Corporate") {
                                                                        // const corp = corporateList.find(c => c.CorporateID === Number(selectedCorporateId));
                                                                        // maxRoom = corp?.MaxRoomBook || 1;
                                                                        maxRoom = 10;
                                                                    }

                                                                    return Array.from({ length: maxRoom }, (_, i) => (
                                                                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                                                                    ));
                                                                })()}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-1 text-end">
                                                        <button type="button" className="btn btn-primary" onClick={handleSearch} style={{ marginTop: "43px" }}>Search</button>
                                                    </div>

                                                </div>

                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {roomDetails.length > 0 && (
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card" style={{ marginBottom: "60px" }}>
                                            <div className="card-header">
                                                <div className="card-title">Room List</div>
                                            </div>
                                            <div className="card-body p-3">
                                                <div className="table-responsive" style={{ overflowX: "auto" }}>
                                                    <table className="table align-middle text-center">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th className="text-start">Room Type</th>
                                                                <th>Room Avl</th>
                                                                {Pms?.PMS === "Opera" && <th style={{ width: "185px" }}>Rate Plan</th>}
                                                                <th style={{ width: "185px" }}>Meal Plan</th>
                                                                <th>Quantity</th>
                                                                <th>Per Room Rate</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {roomDetails.map((room) => {
                                                                // const ratePlans = room.RatePlan ? JSON.parse(room.RatePlan) : [];
                                                                const selectedRate = selectedRatePlans[room.RoomID];
                                                                // const mealPlans = selectedRate ? selectedRate.MealPlan : [];

                                                                return (
                                                                    <tr key={room.RoomID}>
                                                                        {/* Room Name */}
                                                                        <td className="fw-bold text-start">{room.RoomName}</td>

                                                                        <td>{room.count || "0"}</td>

                                                                        {room.count > 0 ? (
                                                                            <>
                                                                                {/* Rate Plan */}
                                                                                {Pms?.PMS === "Opera" && (
                                                                                    <td>
                                                                                        <select
                                                                                            className="form-select"
                                                                                            value={selectedRatePlans[room.RoomID]?.Code || ""}
                                                                                            onChange={(e) => handleRatePlanChange(room.RoomID, e.target.value, room)}
                                                                                        >
                                                                                            <option value="">Select Rate Plan</option>
                                                                                            {ratecode.map((item) => (
                                                                                                <option key={item.RateCodeID} value={item.Code}>
                                                                                                    {item.Name}
                                                                                                </option>
                                                                                            ))}
                                                                                        </select>
                                                                                    </td>
                                                                                )}

                                                                                {/* Meal Plan */}
                                                                                <td>
                                                                                    <select
                                                                                        className="form-select"
                                                                                        value={selectedMealPlans[room.RoomID]?.MealPlanID || ""}
                                                                                        onChange={(e) => handleMealPlanChange(room.RoomID, e.target.value)}
                                                                                    >
                                                                                        <option value="">Select Meal Plan</option>
                                                                                        {filteredMealplan.map(mp => (
                                                                                            <option key={mp.MealPlanID} value={mp.MealPlanID}>
                                                                                                {mp.Name}
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                </td>

                                                                                {/* Quantity */}
                                                                                <td>
                                                                                    {selectedPlans[room.RoomID] && (
                                                                                        roomCounts[room.RoomID] ? (
                                                                                            <div className="hstack gap-2 justify-content-center">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary btn-sm px-2 py-1"
                                                                                                    onClick={() => handleDecrement(room.RoomID)}
                                                                                                >
                                                                                                    <i className="fas fa-minus"></i>
                                                                                                </button>
                                                                                                <span className="fw-semibold">
                                                                                                    {roomCounts[room.RoomID]}
                                                                                                </span>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary btn-sm px-2 py-1"
                                                                                                    onClick={() => handleIncrement(room.RoomID, room.count)}
                                                                                                >
                                                                                                    <i className="fas fa-plus"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        ) : (
                                                                                            <button
                                                                                                className="btn btn-sm btn-primary"
                                                                                                onClick={() => {
                                                                                                    if (Pms?.PMS === "Opera") {
                                                                                                        const selectedRate = selectedRatePlans[room.RoomID]?.Code;
                                                                                                        const selectedMeal = selectedMealPlans[room.RoomID]?.MealPlanID;

                                                                                                        if (!selectedRate || !selectedMeal) {
                                                                                                            alert("Please select Rate Plan and Meal Plan first!");
                                                                                                            return;
                                                                                                        }
                                                                                                    }

                                                                                                    handleSelectRoom(room.RoomID, room.count)
                                                                                                }}
                                                                                            >
                                                                                                Select Room
                                                                                            </button>
                                                                                        )
                                                                                    )}
                                                                                </td>

                                                                                {/* Rate */}
                                                                                <td>
                                                                                    {selectedPlans[room.RoomID] && (
                                                                                        <span className="fw-semibold">
                                                                                            ₹ {selectedPlans[room.RoomID].PerRoomRate}
                                                                                        </span>
                                                                                    )}
                                                                                </td>
                                                                            </>
                                                                        ) : (
                                                                            <td colSpan={Pms?.PMS === "Opera" ? 4 : 3}>
                                                                                <span className="text-danger fw-bold">
                                                                                    No Room Available
                                                                                </span>
                                                                            </td>
                                                                        )}

                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            )}


                            {totalSelectedCount > 0 && (
                                <div
                                    className="bg-light border-top text-end px-4 py-3"
                                    style={{
                                        position: "fixed",
                                        bottom: 0,
                                        left: 0,
                                        width: "100%",
                                        zIndex: 999,
                                        boxShadow: "0 -2px 5px rgba(0,0,0,0.1)"
                                    }}
                                >
                                    <button className="btn btn-primary" onClick={() => setShowPopup(true)}>Continue ( {totalSelectedCount} ) </button>
                                </div>
                            )}



                            {showPopup && (
                                <div
                                    className="modal d-block"
                                    tabIndex="-1"
                                    style={{
                                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        zIndex: 1050,
                                        padding: "18px",
                                    }}
                                >
                                    <div
                                        className="modal-dialog"
                                        style={{
                                            maxWidth: "600px",
                                            width: "100%",
                                        }}
                                    >
                                        <div
                                            className="modal-content"
                                            style={{
                                                borderRadius: "10px",
                                                overflow: "hidden",
                                            }}
                                        >
                                            <div className="modal-header">
                                                <h5 className="modal-title">Selected Rooms</h5>
                                            </div>

                                            <div className="modal-body p-3">
                                                {/* Date display */}
                                                <div className="d-flex justify-content-between mb-3">
                                                    <div><strong>From:</strong> {formatDateToDDMMYYYY(checkIn)}</div>
                                                    <div><strong>To:</strong> {formatDateToDDMMYYYY(checkOut)}</div>
                                                </div>


                                                {roomDetails
                                                    .filter(room => roomCounts[room.RoomID])
                                                    .map((room) => {
                                                        const quantity = roomCounts[room.RoomID] || 0;
                                                        const plan = selectedPlans[room.RoomID];
                                                        const key = `${room.RoomID}-0`;
                                                        const occupancy = roomOccupancy[key] || { adults: 1, children: 0, extraBed: 0 };

                                                        return (
                                                            <div key={room.RoomID} className="bg-light p-3 rounded mb-3 position-relative">
                                                                {/* Room Info */}
                                                                <div className="d-flex justify-content-between mb-2">
                                                                    <strong>{room.RoomName}</strong>
                                                                    <div>
                                                                        {Pms?.PMS === "Opera" && (
                                                                            <span>Rate Plan: <strong className="text-danger">{plan?.RatePlanName}<br /></strong></span>
                                                                        )}


                                                                        <span>Meal Plan: <strong className="text-danger">{plan?.MealPlanName}</strong></span>
                                                                    </div>
                                                                </div>

                                                                {/* Occupancy Controls */}
                                                                <div className="row">
                                                                    <div className="col-md-2">
                                                                        <label className="fw-bold">Rooms</label>
                                                                        <div className="hstack gap-2 mb-2">
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => handleDecrement(room.RoomID)}
                                                                                className="btn btn-outline-secondary btn-sm py-1 px-2"
                                                                            >
                                                                                <i className="fas fa-minus"></i>
                                                                            </button>
                                                                            <span>{quantity}</span>
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => handleIncrement(room.RoomID, room.count)}
                                                                                className="btn btn-outline-secondary btn-sm py-1 px-2"
                                                                            >
                                                                                <i className="fas fa-plus"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-2">
                                                                        <label className="fw-bold">Adults</label>
                                                                        <div className="hstack gap-2 mb-2">
                                                                            <button onClick={() => updateOccupancy(room.RoomID, 0, 'adults', 'decrement')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                                                                <i className="fas fa-minus"></i>
                                                                            </button>
                                                                            <span>{occupancy.adults}</span>
                                                                            <button onClick={() => updateOccupancy(room.RoomID, 0, 'adults', 'increment')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                                                                <i className="fas fa-plus"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-2">
                                                                        <label className="fw-bold">Children</label>
                                                                        <div className="hstack gap-2 mb-2">
                                                                            <button onClick={() => updateOccupancy(room.RoomID, 0, 'children', 'decrement')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                                                                <i className="fas fa-minus"></i>
                                                                            </button>
                                                                            <span>{occupancy.children}</span>
                                                                            <button onClick={() => updateOccupancy(room.RoomID, 0, 'children', 'increment')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                                                                <i className="fas fa-plus"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-3">
                                                                        <label className="fw-bold">Extra Bed</label>
                                                                        <div className="hstack gap-2 mb-2">
                                                                            <button onClick={() => updateOccupancy(room.RoomID, 0, 'extraBed', 'decrement')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                                                                <i className="fas fa-minus"></i>
                                                                            </button>
                                                                            <span>{occupancy.extraBed}</span>
                                                                            <button onClick={() => updateOccupancy(room.RoomID, 0, 'extraBed', 'increment')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                                                                <i className="fas fa-plus"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="fw-bold fs-5 position-absolute" style={{ bottom: "10px", right: "15px" }}>
                                                                    ₹ {roomRates[key] ?? plan?.PerRoomRate}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}


                                            </div>

                                            <div className="modal-footer">
                                                <button className="btn btn-danger" onClick={() => setShowPopup(false)}>Cancel</button>
                                                <button className="btn btn-primary" onClick={handleContinueBooking}>Continue</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}


                        </div>
                    </div>
                </div>

            </div >

            {/* <Ifream/> */}
        </>
    )
}
